import React, { useState } from 'react';
import { Modal, Tooltip } from 'antd';
import ChangePasswrod from './password_form';
import { StyledButton } from 'component/button_components/button_general/ButtonGeneralStyle';
import { ReactComponent as KeyIcon } from 'assets/images/SVG/icons/key-icon.svg';
import { SpanButton } from 'component/button_components/button.style';
import { SweetSweetAlert } from 'component/sweetalert_components';
import { getOneUser } from 'redux/slices/createUser';
import ModalOpenLoader from 'component/loader_component/modalOpenLoader';
import { useDispatch, useSelector } from 'react-redux';

export default function ChangePasswordModal({ ...record }) {
  const role = localStorage.getItem('role');
  const [open, setOpen] = useState(false);
  const [loader, setLoader] = useState(false);
  const [singleUserData, setSingleUserData] = useState(null);
  const dispatch = useDispatch();
  const selectedNode = useSelector((state) => state.selectedNode);

  const showModal = async () => {
    try {
      setLoader(true);
      const sweetAlert = await dispatch(
        getOneUser({ userName: record.dn, fqdn: selectedNode.domainName, domainId: selectedNode.currentdomainId })
      );
      if (sweetAlert.payload && sweetAlert.payload.status === 200) {
        setSingleUserData(sweetAlert.payload.data);
        setOpen(true);
      }
    } catch (error) {
      SweetSweetAlert({ text: 'Something Wrong Please try again.!!', icon: 'error', buttonColor: 'red' });
    } finally {
      setLoader(false);
    }
  };

  const handleCancel = () => {
    setOpen(false);
  };
  return (
    <>
      <Tooltip title='Reset Password' color='#597081' className='af-user-reset-tooltip'>
        {role === 'user' ? (
          <StyledButton type='primary' onClick={showModal} className='af-userpage-changepassword'>
            Change Password
          </StyledButton>
        ) : (
          <SpanButton onClick={showModal} className='af-user-reset-tooltip-button'>
            <KeyIcon className='af-user-reset-tooltip-icon' />
          </SpanButton>
        )}
      </Tooltip>
      {loader && <ModalOpenLoader />}
      <div>
        {open && (
          <Modal
            className='af-user-reset-modal'
            open={open}
            onCancel={handleCancel}
            maskClosable={false}
            footer={[null]}
            centered
          >
            <ChangePasswrod handleCancel={handleCancel} singleUserData={singleUserData} {...record} />
          </Modal>
        )}
      </div>
    </>
  );
}
